"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9770],{

/***/ 52007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1677);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87251);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65243);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button, sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(rest), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), isHovering = _$ref1[0], setIsHovering = _$ref1[1], hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useMedia)().hoverNone, handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!0), onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]), handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!1), onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]), color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : void 0,
                children: label
            }),
            chevronIcon === "right" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});



/***/ }),

/***/ 97402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ ValidatedTextInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/TextInputBase.js + 4 modules
var TextInputBase = __webpack_require__(45553);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/mailcheck/src/mailcheck.js
var mailcheck = __webpack_require__(62320);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js + 2 modules
var parsePhoneNumber = __webpack_require__(75565);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/AsYouType.js + 8 modules
var AsYouType = __webpack_require__(5559);
// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__(83868);
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/ValidatedTextInput/helpers.js







var validateInputValue = function(handleValidationChange, value, type, required, customErrorMessages) {
    var ref, ref1, ref2;
    var errorMessages = {
        fieldRequired: (ref = customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired) !== null && ref !== void 0 ? ref : "This field is required",
        invalidEmail: (ref1 = customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.invalidEmail) !== null && ref1 !== void 0 ? ref1 : "Please enter a valid email address",
        invalidPhoneNumber: (ref2 = customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.invalidPhoneNumber) !== null && ref2 !== void 0 ? ref2 : "Please enter a valid phone number"
    };
    if (value === "" && required) handleValidationChange(errorMessages.fieldRequired);
    else if (type === "emailAddress" && value.length > 0) {
        var isEmailValid = validateEmail(value) ? errorMessages.invalidEmail : void 0;
        handleValidationChange(isEmailValid);
    } else if (type === "telephoneNumber" && value.length > 0) {
        var isPhoneValid = validatePhoneNumber(value) ? errorMessages.invalidPhoneNumber : void 0;
        handleValidationChange(isPhoneValid);
    } else handleValidationChange(void 0);
}, BLACKLISTED_TLDS = [
    "como",
    "comp",
    "con",
    "met",
    "ner",
    "vom"
], validateEmail = function(value) {
    var tld = value.split(".").pop(), blackListed = tld ? BLACKLISTED_TLDS.includes(tld) : !1;
    return !isEmail_default()(value) || blackListed;
}, validatePhoneNumber = function(value) {
    var ref;
    return !((ref = (0,parsePhoneNumber/* parsePhoneNumber */.S)(value, "US")) === null || ref === void 0 ? void 0 : ref.isValid());
}, formatInputValue = function(value, type, getValue) {
    var unformattedValue = value, formattedValue = value;
    return type === "percentage" && (formattedValue = clampPercentage(value), unformattedValue = formattedValue), (type === "number" || type === "dollars") && (unformattedValue = unformatNumber(value), formattedValue = formatNumber(value)), type === "telephoneNumber" && (unformattedValue = unFormatPhoneNumber(value), formattedValue = formatPhoneNumber(value)), getValue && getValue({
        formattedValue: formattedValue,
        unformattedValue: unformattedValue
    }), formattedValue;
}, clampPercentage = function(text) {
    var digits = text.replace(/\D/g, "");
    return digits.startsWith("0") ? "0" : digits.startsWith("100") ? "100" : digits.substring(0, 2);
}, unformatNumber = function(value) {
    return value.replace(/\D/g, "");
}, MAX_NUMBER_LENGTH = 15, MAX_NUMBER_LENGTH_WITH_COMMAS = 19, formatNumber = function(dollars) {
    var digits = dollars.replace(/\D/g, "").slice(0, MAX_NUMBER_LENGTH);
    if (digits === "") return digits;
    var value = parseInt(digits, 10);
    return new Intl.NumberFormat("en-US").format(value);
}, unFormatPhoneNumber = function(value) {
    return value.replace(/\D/g, "");
}, formatPhoneNumber = function(value) {
    return value[0] === "(" && value.length <= 4 || (value = new AsYouType/* AsYouType */.R("US").input(value)), value;
}, mailcheckDefaultDomains = [
    // Keep in sync with app/services/BriteVerifyService
    "yahoo.com",
    "google.com",
    "hotmail.com",
    "gmail.com",
    "me.com",
    "aol.com",
    "mac.com",
    "live.com",
    "comcast.net",
    "googlemail.com",
    "msn.com",
    "facebook.com",
    "verizon.net",
    "sbcglobal.net",
    "att.net",
    "mail.com",
    "outlook.com",
    "icloud.com",
    "cox.net"
], mailcheckDefaultTopLevelDomains = [
    "com",
    "net",
    "org",
    "info",
    "edu"
], suggestEmail = function(email) {
    return new Promise(function(resolve) {
        mailcheck.run({
            domains: mailcheckDefaultDomains,
            email: email,
            empty: function() {
                return resolve("");
            },
            suggested: function(suggestion) {
                suggestion && suggestion.domain.includes(".") ? resolve(JSON.stringify(suggestion.full).replace(/"/g, "")) : resolve("");
            },
            topLevelDomains: mailcheckDefaultTopLevelDomains
        });
    });
}, getSuggestion = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(value, type) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(type === "emailAddress")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        suggestEmail(value)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function getSuggestion(value, type) {
        return _ref.apply(this, arguments);
    };
}(), getFormatProps = function(param) {
    var format = param.format, value = param.value;
    switch(format){
        case "none":
            return {
                textContentType: "none",
                keyboardType: "default"
            };
        case "emailAddress":
            return {
                textContentType: "emailAddress",
                keyboardType: "email-address"
            };
        case "telephoneNumber":
            return {
                textContentType: "telephoneNumber",
                keyboardType: "phone-pad",
                maxLength: 16
            };
        case "password":
            return {
                textContentType: "password",
                keyboardType: "default"
            };
        case "percentage":
            return {
                inputMode: "numeric",
                suffix: value && value.length > 0 ? "%" : void 0,
                /**
         * Note: There's currently an issue with React Native where controlled
         * inputs can cause flickering if you type really quickly because the
         * native text value is set before the JS state. Setting a precise
         * maxLength seems to help.  If we encounter issues in the future, we
         * might consider setting the native text value ourselves.
         * See: https://github.com/facebook/react-native/issues/23578#issuecomment-1903470830
         */ maxLength: value && value[0] === "1" && value[1] === "0" ? 3 : value && value[0] === "0" ? 1 : 2
            };
        case "number":
            return {
                inputMode: "numeric",
                maxLength: MAX_NUMBER_LENGTH_WITH_COMMAS
            };
        case "dollars":
            return {
                inputMode: "numeric",
                prefix: "$",
                maxLength: MAX_NUMBER_LENGTH_WITH_COMMAS
            };
    }
}, useDebounce = function(callback, delay) {
    var callbackRef = (0,react.useRef)(callback);
    (0,react.useLayoutEffect)(function() {
        callbackRef.current = callback;
    });
    var timer;
    var naiveDebounce = function(func, delayMs) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        clearTimeout(timer), timer = setTimeout(function() {
            func.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
        }, delayMs);
    };
    return (0,react.useMemo)(function() {
        return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return naiveDebounce.apply(void 0, [
                callbackRef.current,
                delay
            ].concat((0,_to_consumable_array/* default */.Z)(args)));
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        delay
    ]);
};


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/ValidatedTextInput/ValidatedTextInput.js










var ValidatedTextInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var onBlur = _param.onBlur, format = _param.format, _required = _param.required, required = _required === void 0 ? !1 : _required, prefilledValue = _param.prefilledValue, onChangeText = _param.onChangeText, onValidationChange = _param.onValidationChange, allowSuggestions = _param.allowSuggestions, /**
   * Passing errorText will immediately invoke an error - this is useful to trigger an error on things like async server errors
   * In most cases you will want ValidateTextInput to handle validation/error messsages for you
   * In cases where you want to customize your error message use customErrorMessages instead - the error message will then show based on the error type
   */ errorText = _param.errorText, customErrorMessages = _param.customErrorMessages, getValue = _param.getValue, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onBlur",
        "format",
        "required",
        "prefilledValue",
        "onChangeText",
        "onValidationChange",
        "allowSuggestions",
        "errorText",
        "customErrorMessages",
        "getValue"
    ]);
    var _$ref = (0,react.useState)("unknown"), validationState = _$ref[0], setValidationState = _$ref[1], _$ref1 = (0,react.useState)(prefilledValue || ""), currentValue = _$ref1[0], setCurrentValue = _$ref1[1], _$ref2 = (0,react.useState)(), suggestion = _$ref2[0], setSuggestion = _$ref2[1], _$ref3 = (0,react.useState)(errorText), errorMessage = _$ref3[0], setErrorMessage = _$ref3[1], inputRef = (0,react.useRef)(null), combinedInputRef = (0,cjs.useComposedRefs)(ref, inputRef), formatProps = (0,react.useMemo)(function() {
        return getFormatProps({
            format: format,
            value: currentValue
        });
    }, [
        format,
        currentValue
    ]), handleValidationChange = (0,react.useCallback)(function(currentErrorMessage) {
        setErrorMessage(currentErrorMessage);
        var newValidationState = currentErrorMessage ? "invalid" : "valid";
        setValidationState(newValidationState), onValidationChange && onValidationChange(newValidationState);
    }, [
        onValidationChange
    ]), validateInput = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var suggestedValue;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(validateInputValue(handleValidationChange, value, format, required, customErrorMessages), allowSuggestions)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getSuggestion(value, format)
                        ];
                    case 1:
                        suggestedValue = _state.sent();
                        setSuggestion(suggestedValue);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        format,
        required,
        allowSuggestions,
        customErrorMessages,
        handleValidationChange
    ]), debouncedValidateInput = useDebounce(validateInput, 1e3), handleBlur = function(e) {
        validateInput(currentValue), onBlur && onBlur(e);
    }, selectionRef = (0,react.useRef)({
        start: 0,
        end: 0
    }), handleSelectionChange = function(param) {
        var selection = param.nativeEvent.selection;
        selectionRef.current = selection;
    }, handleChange = (0,react.useCallback)(function(text) {
        var formattedValue = formatInputValue(text, format, getValue);
        if (setCurrentValue(formattedValue), setErrorMessage(""), setValidationState("unknown"), onValidationChange && onValidationChange("unknown"), onChangeText && onChangeText(formattedValue), debouncedValidateInput(text), formattedValue !== text) {
            var inputElement = inputRef.current;
            if (inputElement) {
                var currentTextLength = text.length, textLengthChange = formattedValue.length - currentTextLength;
                "selectionStart" in inputElement && handleCursorUpdateWeb(inputElement, textLengthChange);
            }
        }
    }, [
        format,
        onChangeText,
        onValidationChange,
        getValue,
        debouncedValidateInput
    ]);
    (0,react.useEffect)(function() {
        prefilledValue && (validateInputValue(handleValidationChange, prefilledValue, format, required, customErrorMessages), setCurrentValue(formatInputValue(prefilledValue, format, getValue)));
    }, []);
    var prevFormat = (0,react.useRef)(format);
    return (0,react.useEffect)(function() {
        var revalidate = function() {
            validateInputValue(handleValidationChange, currentValue, format, required, customErrorMessages), setCurrentValue(formatInputValue(currentValue, format, getValue));
        };
        format !== prevFormat.current && revalidate(), prevFormat.current = format;
    }, [
        format,
        handleValidationChange,
        currentValue,
        required,
        customErrorMessages,
        getValue
    ]), /* @__PURE__ */ (0,jsx_runtime.jsx)(TextInputBase/* TextInputBase */.y, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatProps, props), {
        ref: combinedInputRef,
        required: required,
        errorText: errorMessage || errorText,
        onChangeText: handleChange,
        value: currentValue,
        onBlur: handleBlur,
        invalid: validationState === "invalid",
        suggestion: suggestion,
        onSuggestion: function() {
            suggestion && (setCurrentValue(suggestion), setSuggestion(void 0), validateInput(suggestion));
        },
        onSelectionChange: handleSelectionChange
    }));
}), handleCursorUpdateWeb = function(inputElement, textLengthChange) {
    var cursorPosition = inputElement.selectionStart;
    if (cursorPosition !== null) {
        var newCursorPosition = cursorPosition + textLengthChange;
        window.requestAnimationFrame(function() {
            inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
        });
    }
};



/***/ }),

/***/ 64971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ CheckboxGroup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/shared/TrackableContainer.js
var TrackableContainer = __webpack_require__(45822);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/shared/hooks.js
var hooks = __webpack_require__(49555);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/shared/CheckboxRadioGroupError.js
var CheckboxRadioGroupError = __webpack_require__(4192);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/shared/CheckboxRadioGroupLabel.js
var CheckboxRadioGroupLabel = __webpack_require__(33935);
// EXTERNAL MODULE: ./node_modules/@tamagui/checkbox-headless/dist/esm/useCheckbox.mjs + 2 modules
var useCheckbox = __webpack_require__(70357);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Checkmark.js
var Checkmark = __webpack_require__(74816);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/useObservabilitySafe.js
var useObservabilitySafe = __webpack_require__(1252);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/utils.js
var utils = __webpack_require__(56350);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/shared/CheckboxRadioLabel.js
var CheckboxRadioLabel = __webpack_require__(69973);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/shared/hooks.js
var shared_hooks = __webpack_require__(68362);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/SingleCheckbox.js















var checkboxTokens = Components/* tokens.radioCheckbox */.T.radioCheckbox, SingleCheckbox = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, label = _param.label, value = _param.value, subtitle = _param.subtitle, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? !1 : _defaultChecked, disabled = _param.disabled, invalid = _param.invalid, id = _param.id, onPress = _param.onPress, name = _param.name, trackImpression = _param.trackImpression, checked = _param.checked, _hiddenCheckIcon = _param.hiddenCheckIcon, hiddenCheckIcon = _hiddenCheckIcon === void 0 ? !1 : _hiddenCheckIcon, required = _param.required, renderLabel = _param.renderLabel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "label",
        "value",
        "subtitle",
        "defaultChecked",
        "disabled",
        "invalid",
        "id",
        "onPress",
        "name",
        "trackImpression",
        "checked",
        "hiddenCheckIcon",
        "required",
        "renderLabel"
    ]);
    var _$ref = (0,cjs.useProps)(props), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, trackJourneyEvent = (0,useObservabilitySafe/* useObservabilitySafe */.r)().trackJourneyEvent, _$ref1 = (0,react.useState)(defaultChecked), internalChecked = _$ref1[0], setInternalChecked = _$ref1[1];
    (0,react.useEffect)(function() {
        checked !== void 0 && setInternalChecked(checked);
    }, [
        checked
    ]);
    var onCheckedChange = function(e) {
        e.stopPropagation(), onPress && onPress(value, !internalChecked), trackJourneyEvent("platform", "checkboxClickEvent", {
            targetName: analyticsName,
            optionName: value
        });
    }, _$ref2 = (0,useCheckbox/* useCheckbox */.O)((0,_object_spread/* default */.Z)({
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        disabled: disabled,
        onPress: onCheckedChange
    }, props), [
        internalChecked,
        setInternalChecked
    ], ref), checkboxProps = _$ref2.checkboxProps, checkboxRef = _$ref2.checkboxRef, bubbleInput = _$ref2.bubbleInput, inputId = (0,hooks/* useInputId */.U0)(id), _$ref3 = (0,shared_hooks/* useCheckBoxRadioState */.D)({
        checked: internalChecked,
        disabled: disabled,
        invalid: invalid,
        onBlur: props.onBlur,
        onFocus: props.onFocus
    }), rowState = _$ref3.rowState, buttonState = _$ref3.buttonState, handleFocus = _$ref3.handleFocus, handleBlur = _$ref3.handleBlur, _$ref4 = getCheckMarkIconStyle(size, buttonState), checkMarkSize = _$ref4.checkMarkSize, checkMarkColor = _$ref4.checkMarkColor, defaultLabel = /* @__PURE__ */ (0,jsx_runtime.jsx)(CheckboxRadioLabel/* CheckboxRadioLabel */.a, {
        id: inputId,
        label: label,
        size: size,
        subtitle: subtitle,
        state: rowState
    }), labelContent = renderLabel ? renderLabel(defaultLabel) : defaultLabel;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "checkboxViewEvent",
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(CheckboxRowButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, checkboxProps), {
            "aria-invalid": cjs.isWeb ? invalid : void 0,
            "aria-required": cjs.isWeb ? required : void 0,
            ref: checkboxRef,
            size: size,
            state: rowState,
            onFocus: handleFocus,
            onBlur: handleBlur,
            focusable: !disabled,
            id: inputId,
            children: [
                labelContent,
                hiddenCheckIcon ? null : /* @__PURE__ */ (0,jsx_runtime.jsxs)(CheckMarkFrame, {
                    disabled: disabled,
                    size: size,
                    state: {
                        state: buttonState,
                        checked: internalChecked
                    },
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    focusable: !1,
                    children: [
                        internalChecked === !0 && /* @__PURE__ */ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                            size: checkMarkSize,
                            color: checkMarkColor
                        }),
                        bubbleInput
                    ]
                })
            ]
        }))
    });
}), CheckboxRowButton = (0,cjs.styled)(cjs.View, {
    tag: "button",
    display: "flex",
    flexDirection: "row",
    gap: checkboxTokens.padding.textCheckboxGap.default,
    variants: {
        /**
     * Size is here to get types to work
     */ size: function(_size) {
            return {};
        },
        /**
     * State and size are used in the same function because there are multiple
     * times we need to use both to determine the style (especially for
     * small/xsmall)
     */ state: function(state, param) {
            var props = param.props;
            var size = props.size;
            return (0,shared_hooks/* getCustomRadioCheckboxRowStyling */.q)({
                size: size,
                state: state
            });
        }
    }
}), CheckMarkFrame = (0,cjs.styled)(cjs.Stack, {
    borderWidth: checkboxTokens.borderWidth.default,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    alignSelf: "center",
    variants: {
        size: function(size) {
            var buttonSize = size === "xsmall" || size === "small" ? "smallXsmall" : size, widthAndHeight = {
                smallXsmall: 24,
                medium: 26,
                large: 32
            };
            return {
                borderRadius: checkboxTokens.cornerRadius.element.checkbox[buttonSize],
                width: widthAndHeight[buttonSize],
                height: widthAndHeight[buttonSize]
            };
        },
        // eslint-disable-next-line jsdoc/require-jsdoc
        state: function(param) {
            var state = param.state, checked = param.checked;
            var borderColor = (0,utils/* isKeyOfObject */.E)(state, checkboxTokens.color.border.element.checkbox.state) ? checkboxTokens.color.border.element.checkbox.state[state] : checkboxTokens.color.border.element.checkbox.default, backgroundColor = (checked || state === "inactive") && (0,utils/* isKeyOfObject */.E)(state, checkboxTokens.color.background.element.checkboxRadio.state) ? checkboxTokens.color.background.element.checkboxRadio.state[state] : "$transparent";
            return {
                borderColor: borderColor,
                backgroundColor: backgroundColor
            };
        }
    }
}), getCheckMarkIconStyle = function(size, state) {
    return {
        checkMarkSize: size === "small" || size === "xsmall" ? 20 : 24,
        checkMarkColor: (0,utils/* isKeyOfObject */.E)(state, checkboxTokens.color.content.element.checkIcon.state) ? checkboxTokens.color.content.element.checkIcon.state[state] : checkboxTokens.color.content.element.checkIcon.default
    };
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/CheckboxGroup.js















var CheckboxGroup_checkboxTokens = Components/* tokens.radioCheckbox */.T.radioCheckbox, CheckboxGroup = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, options = _param.options, title = _param.title, supportText = _param.supportText, errorText = _param.errorText, invalid = _param.invalid, disabled = _param.disabled, initialCheckedValues = _param.initialCheckedValues, onPress = _param.onPress, id = _param.id, noneOfTheAboveValue = _param.noneOfTheAboveValue, required = _param.required, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "options",
        "title",
        "supportText",
        "errorText",
        "invalid",
        "disabled",
        "initialCheckedValues",
        "onPress",
        "id",
        "noneOfTheAboveValue",
        "required"
    ]);
    var ref = (0,cjs.useProps)(props), _size = ref.size, size = _size === void 0 ? "medium" : _size, groupLabelId = (0,hooks/* useInputId */.U0)(id), state = (0,hooks/* useInputState */.U1)({
        errorText: errorText,
        invalid: invalid,
        disabled: disabled
    }).state, ref1 = (0,react.useState)(initialCheckedValues !== null && initialCheckedValues !== void 0 ? initialCheckedValues : []), checkedValues = ref1[0], setCheckedValues = ref1[1], handleCheckedChange = function(value, _checked) {
        var newCheckedValues;
        value === noneOfTheAboveValue ? newCheckedValues = checkedValues.includes(noneOfTheAboveValue) ? [] : [
            noneOfTheAboveValue
        ] : newCheckedValues = checkedValues.includes(value) ? checkedValues.filter(function(val) {
            return val !== value;
        }) : (0,_to_consumable_array/* default */.Z)(checkedValues.filter(function(val) {
            return val !== noneOfTheAboveValue;
        })).concat([
            value
        ]), setCheckedValues(newCheckedValues), onPress && onPress(newCheckedValues);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        gap: CheckboxGroup_checkboxTokens.padding.titleRowGap[size],
        flexGrow: 1,
        eventName: "checkboxViewEvent",
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(CheckboxRadioGroupLabel/* CheckboxRadioGroupLabel */.L, {
                size: size,
                title: title,
                supportText: supportText,
                id: "".concat(groupLabelId, "-label"),
                state: state,
                required: required
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                role: "group",
                "aria-labelledby": "".concat(groupLabelId, "-label"),
                gap: CheckboxGroup_checkboxTokens.padding.rowGap[size],
                children: options.map(function(option) {
                    var defaultChecked = initialCheckedValues === null || initialCheckedValues === void 0 ? void 0 : initialCheckedValues.includes(option.value), isNoneOfTheAbove = option.value === noneOfTheAboveValue;
                    return /* @__PURE__ */ /*#__PURE__*/ (0,react.createElement)(SingleCheckbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        key: option.value,
                        analyticsName: analyticsName,
                        invalid: !!errorText || invalid,
                        disabled: disabled,
                        label: option.label,
                        subtitle: option.subtitle,
                        size: size,
                        value: option.value,
                        onPress: handleCheckedChange,
                        state: state,
                        defaultChecked: defaultChecked,
                        checked: checkedValues.includes(option.value),
                        id: "".concat(groupLabelId, "-").concat(option.value),
                        name: id,
                        hiddenCheckIcon: isNoneOfTheAbove,
                        renderLabel: option.renderLabel
                    }));
                })
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(CheckboxRadioGroupError/* CheckboxRadioGroupError */.r, {
                errorText: errorText
            })
        ]
    });
};



/***/ }),

/***/ 4192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CheckboxRadioGroupError; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxRadioGroupError = function(param) {
    var errorText = param.errorText;
    return errorText && typeof errorText == "string" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        testID: "checkbox-radio-group-error-message",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            tag: "span",
            typography: radioCheckbox.typography.errorMessage.default,
            color: radioCheckbox.color.content.errorMessage.default,
            children: errorText
        })
    }) : null;
};



/***/ }),

/***/ 33935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ CheckboxRadioGroupLabel; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56350);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var _shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25689);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxRadioGroupLabel = function(param) {
    var size = param.size, title = param.title, supportText = param.supportText, id = param.id, state = param.state, required = param.required;
    return (0,_shared_InputLabelContext__WEBPACK_IMPORTED_MODULE_2__/* .useCheckInputLabel */ .B)(title), title ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "label",
                id: id,
                typography: radioCheckbox.typography.title[size],
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.title.state) ? radioCheckbox.color.content.title.state[state] : radioCheckbox.color.content.title.default,
                children: [
                    title,
                    required ? " *" : ""
                ]
            }),
            !!supportText && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "span",
                typography: radioCheckbox.typography.supportText.default,
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_5__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.supportText.state) ? radioCheckbox.color.content.supportText.state[state] : radioCheckbox.color.content.supportText.default,
                children: supportText
            })
        ]
    }) : null;
};



/***/ }),

/***/ 69973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CheckboxRadioLabel; },
/* harmony export */   "w": function() { return /* binding */ RightAlignedRadioLabel; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56350);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, CheckboxRadioLabel = function(param) {
    var size = param.size, label = param.label, subtitle = param.subtitle, id = param.id, state = param.state;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        alignSelf: "center",
        flex: 3,
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                alignSelf: "flex-start",
                tag: "label",
                numberOfLines: 1,
                htmlFor: id,
                typography: radioCheckbox.typography.valueText[size],
                fontWeight: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(size, radioCheckbox.fontWeight.override) ? radioCheckbox.fontWeight.override[size] : void 0,
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.valueText.state) ? radioCheckbox.color.content.valueText.state[state] : radioCheckbox.color.content.valueText.default,
                children: label
            }),
            !!subtitle && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                alignSelf: "flex-start",
                tag: "span",
                numberOfLines: 1,
                typography: radioCheckbox.typography.valueTextSecondLine[size],
                color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.valueTextRowTwo.state) ? radioCheckbox.color.content.valueTextRowTwo.state[state] : radioCheckbox.color.content.valueTextRowTwo.default,
                children: subtitle
            })
        ]
    });
}, RightAlignedRadioLabel = function(param) {
    var size = param.size, rightAlignedText = param.rightAlignedText, state = param.state;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        alignSelf: "center",
        flex: 1,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            alignSelf: "flex-end",
            tag: "label",
            numberOfLines: 1,
            typography: radioCheckbox.typography.rightAligned[size],
            color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_4__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.content.valueText.state) ? radioCheckbox.color.content.valueText.state[state] : radioCheckbox.color.content.valueText.default,
            paddingRight: size === "xsmall" ? "$6x" : 0,
            children: rightAlignedText
        })
    });
};



/***/ })

}]);